import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=41e530b5"
import script from "./OrderListItem.vue?vue&type=script&lang=js"
export * from "./OrderListItem.vue?vue&type=script&lang=js"
import style0 from "./OrderListItem.vue?vue&type=style&index=0&id=41e530b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports